import Box from "@mui/material/Box";
import React from "react";
import ListHeader from "../../managementShared/ListHeader";
import {
  useDeleteDayoffTypeDocumentMutation,
  useFetchGetDayoffTypeDocumentsQuery,
} from "../../../../store";
import { columns } from "../utils/dayoffDocumentColumns";
import ManagementToolbar from "../../managementShared/ManagementToolbar";
import { useDispatch, useSelector } from "react-redux";
import { setDayoffDocument } from "../../../../store/slices/applicationManagement/managementSlice";
import {
  closeDialog,
  openDialog,
} from "../../../../store/slices/dialog/dialogSlice";
import {
  CONFIRM_DIALOG,
  DAYOFF_DOCUMENT_DIALOG,
} from "../../../../store/slices/utils/dialogEnum";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";
import CustomConfirmDialog from "../../../../components/shared/CustomConfirmDialog";
import { DataGrid } from "@mui/x-data-grid";
import DayoffDocumentForm from "./DayoffDocumentForm";

const DayoffDocumentList = () => {
  const dispatch = useDispatch();
  const { data, isLoading } = useFetchGetDayoffTypeDocumentsQuery();
  const { dayoffDocumentDialogOpen } = useSelector(
    (state) => state.dialogSlice
  );
  const { dayoffDocument } = useSelector((state) => state.managementSlice);
  const handleUpdate = (dayoffDocument) => {
    dispatch(setDayoffDocument(dayoffDocument));
    dispatch(openDialog(DAYOFF_DOCUMENT_DIALOG));
  };

  const handleDelete = (dayoffDocument) => {
    dispatch(setDayoffDocument(dayoffDocument));
    dispatch(openDialog(CONFIRM_DIALOG));
  };

  const closeDelete = () => {
    dispatch(setDayoffDocument(null));
    dispatch(closeDialog(CONFIRM_DIALOG));
  };

  const [deleteDocument, { isLoading: deleteDocumentLoading }] =
    useDeleteDayoffTypeDocumentMutation();

  const postDelete = () => {
    deleteDocument(dayoffDocument.id).then((res) => {
      if (res) {
        if (!res.data.isSuccess) {
          dispatch(openErrorToast(res.data.message));
        } else {
          dispatch(openSuccessToast("İşlem Tamamlandı"));
          closeDelete();
        }
      }
    });
  };
  return (
    <Box
      sx={{
        height: "auto",
        width: "100%",
        marginTop: 10,
        overflowX: "auto",
        minWidth: { xs: 600, sm: 0 },
        flex: "flex",
        flexDirection: "column",
      }}
    >
      <ListHeader text="İzin - Belge Tür Eşleştirmesi" />
      {dayoffDocument && (
        <CustomConfirmDialog
          handleConfirm={postDelete}
          title="İzin - Belge Türü Eşleştirme Silme"
          text="Bu eşleştirmeyi silmek istediğinize emin misiniz?"
          isLoading={deleteDocumentLoading}
          handleClose={closeDelete}
        />
      )}
      {dayoffDocumentDialogOpen && <DayoffDocumentForm />}
      <DataGrid
        rows={data?.data || []}
        loading={isLoading}
        disableColumnMenu
        columns={columns(handleUpdate, handleDelete)}
        pageSizeOptions={[5, 10, 25, 50]}
        disableRowSelectionOnClick
        slots={{
          toolbar: (props) => (
            <ManagementToolbar {...props} dialogType={DAYOFF_DOCUMENT_DIALOG} />
          ),
        }}
        showToolbar
      />
    </Box>
  );
};

export default DayoffDocumentList;
